import { AxiosError } from 'axios'
/* services */
import { ApiService } from './constant.services'
/* models */
import { WalletPaymentResponse } from '@models'

export const WalletPaymentServices = async (invoiceNumber: string) => {
    try {
        const response = await ApiService.get<WalletPaymentResponse>(`business/invoice/number/${invoiceNumber}`)

        if (response.data.error === true) return response.data

        return response.data
    } catch (error) {
        const err = error as AxiosError

        console.log(err.response?.data)

        return err.response?.data
    }
}

export const WalletPaymentInvoiceServices = async (invoiceNumber: string) => {
    try {
        const response = await ApiService.post<WalletPaymentResponse>(`business/invoice/number/${invoiceNumber}`)

        if (response.data.error === true) return response.data

        return response.data
    } catch (error) {
        const err = error as AxiosError

        console.log(err.response?.data)

        return err.response?.data
    }
}
